// Routes for the claims list, settings, new, and edit screens.
import React from "react";

const ClaimsIndex = React.lazy(() => import("./index"));
const ClaimSettings = React.lazy(() => import("./settings"));
const ClaimProject = React.lazy(() => import("./project"));
const NewClaim = React.lazy(() => import("./new"));
const EditClaim = React.lazy(() => import("./edit"));

export default [
  { path: "/administration/claims/project/:projectId", component: ClaimProject, name: "Claim project" },
  { path: "/administration/claims/settings", component: ClaimSettings, name: "Claim settings" },
  { path: "/administration/claims/:id/edit", component: EditClaim, name: "Edit claim" },
  { path: "/administration/claims/new", component: NewClaim, name: "New claim" },
  { path: "/administration/claims", exact: true, component: ClaimsIndex, name: "Claims" },
];
